/**
 * الأيقونات — منسوخة حرفيًا من ملفات التصميم `design/*.dc.html`.
 * كلها 20×20 viewBox · stroke-width 1.7 · مفيش تعبئة.
 * ⚠️ ممنوع تغيير المسارات — دي نفس الأشكال المعتمدة في العرض على الفريق.
 */
import type { ReactElement } from "react";

export type IconName =
  | "book"
  | "chevron"
  | "desk"
  | "team"
  | "journey"
  | "chat"
  | "leads"
  | "student"
  | "teacher"
  | "eval"
  | "shield"
  | "hiring"
  | "record"
  | "director"
  | "access"
  | "search"
  | "bell"
  | "check"
  | "bolt"
  | "mail"
  | "lock"
  | "eye"
  | "eye-off"
  | "alert"
  | "info"
  | "circle-alert"
  | "spinner"
  | "inbox"
  | "file"
  | "wifi-off"
  | "logout";

const PATHS: Record<IconName, ReactElement> = {
  book: (
    <>
      <path d="M10 4c-1.8-1.3-4.2-1.6-6.5-1v12.5c2.3-.6 4.7-.3 6.5 1 1.8-1.3 4.2-1.6 6.5-1V3c-2.3-.6-4.7-.3-6.5 1z" />
      <path d="M10 4v12.5" />
    </>
  ),
  chevron: <path d="M7.5 4.5 12 10l-4.5 5.5" />,
  desk: (
    <>
      <rect x="2.5" y="3.5" width="15" height="13" rx="2" />
      <path d="M2.5 8h15" />
      <path d="M7 12h6" />
    </>
  ),
  team: (
    <>
      <circle cx="7" cy="7.5" r="2.6" />
      <path d="M2.5 16.5c.5-2.7 2.3-4.3 4.5-4.3s4 1.6 4.5 4.3" />
      <circle cx="14.2" cy="8.3" r="2.1" />
      <path d="M13.1 12.6c2-.3 3.9 1 4.4 3.4" />
    </>
  ),
  journey: (
    <>
      <circle cx="4.5" cy="5" r="1.8" />
      <circle cx="15.5" cy="15" r="1.8" />
      <path d="M6.3 5h6.2a3 3 0 0 1 3 3v4.2" />
    </>
  ),
  chat: (
    <>
      <path d="M3 9.2c0-3 3.1-5.2 7-5.2s7 2.2 7 5.2-3.1 5.2-7 5.2c-.8 0-1.6-.1-2.3-.3L4.5 16l.8-2.6C3.9 12.4 3 10.9 3 9.2z" />
      <path d="M7.4 9.2h5.2" />
    </>
  ),
  leads: (
    <>
      <path d="M3 11.5 5.7 5h8.6l2.7 6.5V15a1.5 1.5 0 0 1-1.5 1.5H4.5A1.5 1.5 0 0 1 3 15z" />
      <path d="M3 11.5h4l1.3 1.8h3.4l1.3-1.8h4" />
    </>
  ),
  student: (
    <>
      <rect x="2.5" y="4" width="15" height="12" rx="2" />
      <circle cx="7" cy="9" r="1.7" />
      <path d="M4.8 13.4c.4-1.2 1.3-1.9 2.2-1.9s1.8.7 2.2 1.9" />
      <path d="M11.5 8h4" />
      <path d="M11.5 11h4" />
    </>
  ),
  teacher: (
    <>
      <path d="M4 3.5h9.5a2 2 0 0 1 2 2V16.5H6a2 2 0 0 1-2-2z" />
      <path d="M4 14.5a2 2 0 0 1 2-2h9.5" />
      <circle cx="9.7" cy="7.5" r="1.7" />
    </>
  ),
  eval: (
    <>
      <rect x="4" y="4" width="12" height="13.5" rx="2" />
      <path d="M8 3h4v2.5H8z" />
      <path d="M7.5 11.5l1.9 1.9 3.4-3.6" />
    </>
  ),
  shield: (
    <>
      <path d="M10 2.8 16 5v4.6c0 3.4-2.4 6.1-6 7.6-3.6-1.5-6-4.2-6-7.6V5z" />
      <path d="M7.6 9.8l1.7 1.7 3.2-3.4" />
    </>
  ),
  hiring: (
    <>
      <circle cx="8" cy="7" r="2.6" />
      <path d="M3 16c.5-2.8 2.4-4.4 5-4.4 1 0 1.9.2 2.6.7" />
      <path d="M14 11.5v5" />
      <path d="M11.5 14h5" />
    </>
  ),
  record: (
    <>
      <rect x="2.5" y="5" width="10.5" height="10" rx="2" />
      <path d="M13 9.3 17.5 6.6v6.8L13 10.7z" />
    </>
  ),
  director: (
    <>
      <path d="M3.5 14.5a6.5 6.5 0 1 1 13 0" />
      <path d="M10 14.5l3.2-3.2" />
      <circle cx="10" cy="14.5" r="1.1" />
    </>
  ),
  access: (
    <>
      <circle cx="7.2" cy="9.5" r="3.2" />
      <path d="M10.2 8.4h6.3" />
      <path d="M14.4 8.4v3" />
      <path d="M16.5 8.4v2.2" />
    </>
  ),
  search: (
    <>
      <circle cx="9" cy="9" r="5.5" />
      <path d="M13.5 13.5 17 17" />
    </>
  ),
  bell: (
    <>
      <path d="M5 8a5 5 0 0 1 10 0c0 3 1 4.5 1.8 5.5H3.2C4 12.5 5 11 5 8z" />
      <path d="M8.3 16a1.8 1.8 0 0 0 3.4 0" />
    </>
  ),
  check: <path d="M4.5 10.5 8.2 14l7.3-8" />,
  bolt: <path d="M11 2 4 11.5h5L9 18l7-9.5h-5z" />,
  mail: (
    <>
      <rect x="2.5" y="4.5" width="15" height="11" rx="2" />
      <path d="M3.2 6 10 10.8 16.8 6" />
    </>
  ),
  lock: (
    <>
      <rect x="4" y="8.5" width="12" height="8" rx="2" />
      <path d="M7 8.5V6.8a3 3 0 0 1 6 0v1.7" />
    </>
  ),
  // ⚠️ مش من ملفات التصميم — اتضافت لزرار «إظهار كلمة السر» بنفس المقاس
  //    والسُمك (20×20 · 1.7) عشان تقعد جنب `lock` من غير ما تبان غريبة.
  eye: (
    <>
      <path d="M1.8 10S4.8 4.5 10 4.5 18.2 10 18.2 10 15.2 15.5 10 15.5 1.8 10 1.8 10z" />
      <circle cx="10" cy="10" r="2.6" />
    </>
  ),
  "eye-off": (
    <>
      <path d="M8.2 4.7A8 8 0 0 1 10 4.5c5.2 0 8.2 5.5 8.2 5.5a14 14 0 0 1-2.3 3" />
      <path d="M5.4 6.1C3.1 7.6 1.8 10 1.8 10s3 5.5 8.2 5.5a7.6 7.6 0 0 0 4.2-1.3" />
      <path d="M8.2 8.3a2.6 2.6 0 0 0 3.5 3.5" />
      <path d="M2.5 2.5l15 15" />
    </>
  ),
  alert: (
    <>
      <path d="M10 3.2 17.6 16.3H2.4z" />
      <path d="M10 8.2v3.4" />
      <path d="M10 13.9v.1" />
    </>
  ),
  info: (
    <>
      <circle cx="10" cy="10" r="7" />
      <path d="M10 9.3v4.2" />
      <path d="M10 6.6h.01" />
    </>
  ),
  "circle-alert": (
    <>
      <circle cx="10" cy="10" r="7" />
      <path d="M10 6.5v4" />
      <path d="M10 13.3h.01" />
    </>
  ),
  spinner: <path d="M10 3.2a6.8 6.8 0 1 0 6.8 6.8" />,
  inbox: (
    <>
      <rect x="3" y="4.5" width="14" height="11" rx="2" />
      <path d="M3 10.5h4l1.2 1.7h3.6l1.2-1.7h4" />
    </>
  ),
  file: (
    <>
      <path d="M5 3.5h6.5L15 7v9.5H5z" />
      <path d="M11.3 3.5V7H15" />
      <path d="M7.6 11h4.8" />
      <path d="M7.6 13.6h3" />
    </>
  ),
  "wifi-off": (
    <>
      <path d="M3.2 7.6a11 11 0 0 1 4.1-2.3" />
      <path d="M16.8 7.6a11 11 0 0 0-3.3-2.1" />
      <path d="M5.9 10.6a7 7 0 0 1 2.2-1.3" />
      <path d="M14.1 10.6a7 7 0 0 0-1.6-1.1" />
      <path d="M8.4 13.5a3 3 0 0 1 3.2 0" />
      <path d="M10 16.2h.01" />
      <path d="M3.5 3.5 16.5 16.5" />
    </>
  ),
  logout: (
    <>
      <path d="M12.5 6V4.5a1.5 1.5 0 0 0-1.5-1.5H5a1.5 1.5 0 0 0-1.5 1.5v11A1.5 1.5 0 0 0 5 17h6a1.5 1.5 0 0 0 1.5-1.5V14" />
      <path d="M8.5 10h8" />
      <path d="M14.2 7.5 16.7 10l-2.5 2.5" />
    </>
  ),
};

export function Icon({
  name,
  size = 17,
  stroke = "currentColor",
  strokeWidth = 1.7,
  className,
}: {
  name: IconName;
  size?: number;
  stroke?: string;
  strokeWidth?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  );
}
